<template>
  <div class="people">
    <!-- 选择出行人 -->
    <div v-if="!newaddshow && !changeshow">
      <div class="title">
        <div style="font-size: 0.22rem">选择报名人</div>
        <div @click="newaddshow = true">新增</div>
      </div>
      <div class="people-content">
        <div class="peoplePrompt">*单次报名可添加三名同行人员</div>
        <img
          src="../assets/appointment.png"
          alt=""
          width="100%"
          v-if="peoplelist.length == 0"
        />
        <div
          v-for="(item, index) in peoplelist"
          :key="index"
          class="people-item"
          :class="index != 0 ? 'oneactive' : ''"
        >
          <div class="item-left">
            <div class="change">
              <img
                src="../assets/change.png"
                alt=""
                v-if="ischange(item.id)"
                @click="changepeople(false, item.id)"
              />
              <img
                src="../assets/nochange.png"
                alt=""
                v-else
                @click="changepeople(true, item.id)"
              />
            </div>
            <div class="data">
              <div style="font-size: 0.18rem; color: #000">{{ item.name }}</div>
              <div>
                <span>{{ item.cardType }}</span> {{ item.idCard }}
              </div>
              <div><span>手机号</span>{{ item.phone }}</div>
            </div>
          </div>
          <div class="editor" @click="Mchangeshow(item)">
            <i class="el-icon-edit-outline"></i>
          </div>
          <div
            class="mydelete"
            @click="
              deleteid = item.id;
              deleteshow = true;
            "
          >
            <i class="el-icon-delete"></i>
          </div>
        </div>
      </div>
      <div class="people-bottom">
        <div class="sumbit" @click="addsumbit">确定</div>
      </div>
    </div>
    <!-- 新增出行人 -->
    <div v-if="newaddshow">
      <div class="title">
        <div style="font-size: 0.22rem">添加出行人</div>
      </div>
      <div class="people-content">
        <div class="input-item">
          <div class="input-name">姓名</div>
          <div class="myinput">
            <input v-model="form.name" placeholder="请输入姓名" />
          </div>
        </div>
        <div class="input-item">
          <div class="input-name">证件类型</div>
          <div class="myinput">
            <el-dropdown @command="handleCommand">
              <div class="link">
                <div>{{ form.cardType }}</div>
                <div><i class="el-icon-caret-bottom"></i></div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in cardType"
                  :key="index"
                  :command="index"
                  >{{ item }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="input-item">
          <div class="input-name">证件号码</div>
          <div class="myinput">
            <input v-model="form.idCard" placeholder="请输入证件号码" />
          </div>
        </div>
        <div class="input-item">
          <div class="input-name">手机号码</div>
          <div class="myinput">
            <input v-model="form.phone" placeholder="请输入手机号码" />
          </div>
        </div>
        <div class="prompt">
          温馨提示：身份证信息与手机号需与健康码所关联的身份信息相匹配。
        </div>
      </div>
      <div class="people-bottom1">
        <div class="cancel" @click="newaddshow = false">取消</div>
        <div class="sumbit1" @click="newaddsumbit">确定</div>
      </div>
    </div>
    <!-- 编辑出行人 -->
    <div v-if="changeshow">
      <div class="title">
        <div style="font-size: 0.22rem">编辑出行人</div>
      </div>
      <div class="people-content">
        <div class="input-item">
          <div class="input-name">姓名</div>
          <div class="myinput">
            <input v-model="changeform.name" placeholder="请输入姓名" />
          </div>
        </div>
        <div class="input-item">
          <div class="input-name">证件类型</div>
          <div class="myinput">
            <el-dropdown @command="handleCommand1">
              <div class="link">
                <div>{{ changeform.cardType }}</div>
                <div><i class="el-icon-caret-bottom"></i></div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in cardType"
                  :key="index"
                  :command="index"
                  >{{ item }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="input-item">
          <div class="input-name">证件号码</div>
          <div class="myinput">
            <input v-model="changeform.idCard" placeholder="请输入证件号码" />
          </div>
        </div>
        <div class="input-item">
          <div class="input-name">手机号码</div>
          <div class="myinput">
            <input v-model="changeform.phone" placeholder="请输入手机号码" />
          </div>
        </div>
        <div class="prompt">
          温馨提示：身份证信息与手机号需与健康码所关联的身份信息相匹配。
        </div>
      </div>
      <div class="people-bottom1">
        <div class="cancel" @click="changeshow = false">取消</div>
        <div class="sumbit1" @click="changesumbit">确定</div>
      </div>
    </div>
    <!-- 提示框 -->
    <el-dialog
      :visible.sync="pullshow"
      width="70%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-centent"
    >
      <div class="pull-con">
        <div class="pull-con-title1">温馨提示</div>
        <div class="pull-con-title2">{{ mytext }}</div>
        <div class="pull-con-title3" @click="pullshow = false">知道了</div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="deleteshow"
      width="70%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-centent"
    >
      <div class="pull-con1">
        <div class="pull-con-title1">温馨提示</div>
        <div class="pull-con-title2">确定删除出行人吗？</div>
        <div class="pull-button">
          <div
            @click="deleteshow = false"
            style="background-color: rgba(167, 141, 96, 0.3); color: #a78d60"
          >
            取消
          </div>
          <div
            @click="mydelete()"
            style="background-color: #a78d60; color: #fff"
          >
            确定
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      peoplelist: [],
      cardType: ["二代身份证", "护照", "台胞证", "港澳通行证","外国人永久居留身份证"],
      pullshow: false,
      newaddshow: false,
      changeshow: false,
      form: {
        name: "",
        cardType: "二代身份证",
        idCard: "",
        phone: "",
      },
      changeform: {},
      mytext: "",
      deleteshow: false,
      deleteid: "",
      newsumbit: true,
      xiusumbit: true,
    };
  },
  watch: {
    newaddshow(val) {
      if (!val) {
        (this.form = {
          name: "",
          cardType: "二代身份证",
          idCard: "",
          phone: "",
        }),
          this.getuserpeo();
      }
    },
    changeshow(val) {
      if (!val) {
        this.changeform = {};
        this.getuserpeo();
      }
    },
  },
  //存入选择出行人的id
  props: {
    peopleindex: {
      type: Array,
      default: () => [],
    },
  },
  model: {
    prop: "peopleindex",
    event: "change",
  },
  created() {
    this.getuserpeo();
  },
  methods: {
    // 判断是否为选中出行人
    ischange(id) {
      let show = false;
      console.log(this.peopleindex)
      this.peopleindex.forEach((element) => {
        if (id == element) {
          show = true;
        }
      });
      return show;
    },
    // 选择出行人
    changepeople(show, id) {
      if (show) {
        if (this.peopleindex.length >= 3) {
          this.mytext = "最多一次只能添加三位报名人";
          this.pullshow = true;
        } else {
          this.peopleindex.push(id);
        }
      } else {
        let deleteindex = this.peopleindex.findIndex((value) => {
          return value == id;
        });
        this.$delete(this.peopleindex, deleteindex);
      }
    },
    addsumbit() {
      this.$emit("changeshow");
    },
    handleCommand(val) {
      this.form.cardType = this.cardType[val];
    },
    handleCommand1(val) {
      this.changeform.cardType = this.cardType[val];
    },
    // 新增出行人
    newaddsumbit() {
      if (this.newsumbit) {
        this.newsumbit = false;
        for (const item in this.form) {
          if (!this.form[item].replace(/^\s*/, "")) {
            this.changeporomt("身份信息不能为空", false);
            return false;
          }
        }
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.phone)) {
          this.changeporomt("请录入正确的手机号码！", false);
          return false;
        }
        if (this.form.cardType == "二代身份证") {
          let regIdNo =
            /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!regIdNo.test(this.form.idCard)) {
            this.changeporomt("证号号码填写有误！", false);
            return false;
          }
          this.$axios
            .post("/book/identity", {
              idCard: this.form.idCard,
              name: this.form.name,
            })
            .then((res) => {
              if (res.code == 200) {
                this.$axios
                  .post("/userpeo/add", {
                    name: this.form.name,
                    idCard: this.form.idCard,
                    phone: this.form.phone,
                    cardType: this.form.cardType,
                  })
                  .then((res) => {
                    if (res.code == 200) {
                      this.newaddshow = false;
                    }
                    this.newsumbit = true;
                  })
                  .catch(() => {
                    this.newsumbit = true;
                  });
              } else {
                this.changeporomt(res.msg, false);
              }
            })
            .catch(() => {
              this.newsumbit = true;
            });
        } else {
          this.$axios
            .post("/userpeo/add", {
              name: this.form.name,
              idCard: this.form.idCard,
              phone: this.form.phone,
              cardType: this.form.cardType,
            })
            .then((res) => {
              if (res.code == 200) {
                this.newaddshow = false;
              }
              this.newsumbit = true;
            })
            .catch(() => {
              this.newsumbit = true;
            });
        }
      } else {
        console.log("请勿频繁操作");
      }
    },
    changeporomt(text, show) {
      this.mytext = text;
      this.pullshow = true;
      if (show) {
        this.xiusumbit = true;
      } else {
        this.newsumbit = true;
      }
    },
    // 修改出行人
    changesumbit() {
      if (this.xiusumbit) {
        this.xiusumbit = false;
        for (const item in this.changeform) {
          if (!this.changeform[item].replace(/^\s*/, "")) {
            this.changeporomt("身份信息不能为空", true);
            return false;
          }
        }
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.changeform.phone)) {
          this.changeporomt("请录入正确的手机号码！", true);
          return false;
        }
        if (this.changeform.cardType == "二代身份证") {
          let regIdNo =
            /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!regIdNo.test(this.changeform.idCard)) {
            this.changeporomt("证号号码填写有误！", true);
            return false;
          }
          this.$axios
            .post("/book/identity", {
              idCard: this.changeform.idCard,
              name: this.changeform.name,
            })
            .then((res) => {
              if (res.code == 200) {
                this.$axios
                  .post("/userpeo/update", this.changeform)
                  .then((res) => {
                    if (res.code == 200) {
                      this.changeshow = false;
                    }
                    this.xiusumbit = true;
                  })
                  .catch(() => {
                    this.xiusumbit = true;
                  });
              } else {
                this.changeporomt(res.msg, true);
              }
            })
            .catch(() => {
              this.xiusumbit = true;
            });
        } else {
          this.$axios
            .post("/userpeo/update", this.changeform)
            .then((res) => {
              if (res.code == 200) {
                this.changeshow = false;
              }
              this.xiusumbit = true;
            })
            .catch(() => {
              this.xiusumbit = true;
            });
        }
      }
    },
    mydelete() {
      this.$axios.delete("/userpeo/delete?id=" + this.deleteid).then(() => {
        this.$message.success("删除成功");
        this.getuserpeo();
        this.deleteshow = false;
      });
    },
    Mchangeshow(item) {
      this.changeshow = true;
      this.changeform = item;
    },
    getuserpeo() {
      this.$axios.get("/userpeo/list").then((res) => {
        this.peoplelist = res.data;
        this.peoplelist.forEach(element => {
            this.$set(element,'idCard',this.$crypto.decrypt(element.idCard,"Mse1FuwMgIF6cR5p","Xadiapdfaxi0s91D"))
        });
      });
    },
  },
};
</script>

<style>
.el-dialog-centent {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
}
.el-dialog__header {
  display: none;
}
</style>
<style scoped lang="less">
.people {
  width: 100%;
  height: 100%;
  .title {
    background-color: #a78d60;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.2rem 0.1rem 0.2rem;
    box-sizing: border-box;
    color: #fff;
  }
  .people-content {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;
    .peoplePrompt {
      font-size: 0.1rem;
      color: #a0a0a0;
      line-height: 0.18rem;
    }
    .people-item {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 0.2rem;
      padding-top: 0.2rem;
      // padding-bottom: 0.2rem;
      .item-left {
        display: flex;
        .change {
          width: 0.2rem;
          height: 0.2rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .active {
          background-color: #a78d60;
        }
        .data {
          margin-left: 0.2rem;
          line-height: 0.25rem;
          color: #868686;
          font-size: 0.13rem;
          span {
            margin-right: 0.1rem;
          }
        }
      }
      .editor {
        font-size: 0.2rem;
        vertical-align: text-top;
      }
      .mydelete {
        font-size: 0.2rem;
        vertical-align: text-top;
      }
    }
    .oneactive {
      border-top: 1px solid rgba(20, 35, 35, 0.2);
    }
    .input-item {
      width: 100%;
      display: flex;
      line-height: 0.5rem;
      border-bottom: 1px solid rgba(20, 35, 35, 0.2);
      .input-name {
        width: 30%;
        font-size: 0.18rem;
      }
      .myinput {
        width: 70%;
        color: #606266;
        input {
          border: 0;
          padding-left: 0;
          outline: none;
          background-color: #ffffff;
          font-size: 0.18rem;
          color: #606266;
        }
        .el-dropdown {
          width: 100%;
          font-size: 0.18rem;
        }
        .el-dropdown :focus{
          outline: 0;
        }
        .link {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        input::-webkit-input-placeholder {
          /*WebKit browsers*/
          color: rgba(96, 98, 102, 0.5);
          font-size: 0.18rem;
        }

        input::-moz-input-placeholder {
          /*Mozilla Firefox*/
          color: rgba(96, 98, 102, 0.5);
          font-size: 0.18rem;
        }

        input::-ms-input-placeholder {
          /*Internet Explorer*/
          color: rgba(96, 98, 102, 0.5);
          font-size: 0.18rem;
        }
      }
    }
    .prompt {
      color: #a0a0a0;
      font-size: 0.12rem;
      // white-space: nowrap;
      // text-align: center;
      margin-top: 0.5rem;
    }
  }
  .people-bottom {
    width: 100%;
    max-width: 768px;
    padding: 0 0.2rem;
    box-sizing: border-box;
    position: fixed;
    bottom: 0.2rem;
    display: flex;
    justify-content: space-between;
    .sumbit {
      background-color: #a78d60;
      line-height: 0.4rem;
      color: #fff;
      width: 100%;
      text-align: center;
      border-radius: 0.05rem;
    }
    .sumbit1 {
      background-color: #a78d60;
      line-height: 0.4rem;
      color: #fff;
      width: 42%;
      text-align: center;
      border-radius: 0.05rem;
    }
    .cancel {
      background-color: rgba(167, 141, 96, 0.2);
      color: #a78d60;
      width: 42%;
      line-height: 0.4rem;
      text-align: center;
      border-radius: 0.05rem;
    }
  }
  .people-bottom1 {
    width: 100%;
    max-width: 768px;
    padding: 0 0.2rem;
    box-sizing: border-box;
    position: absolute;
    bottom: 0.2rem;
    display: flex;
    justify-content: space-between;
    .sumbit {
      background-color: #a78d60;
      line-height: 0.4rem;
      color: #fff;
      width: 100%;
      text-align: center;
      border-radius: 0.05rem;
    }
    .sumbit1 {
      background-color: #a78d60;
      line-height: 0.4rem;
      color: #fff;
      width: 42%;
      text-align: center;
      border-radius: 0.05rem;
    }
    .cancel {
      background-color: rgba(167, 141, 96, 0.2);
      color: #a78d60;
      width: 42%;
      line-height: 0.4rem;
      text-align: center;
      border-radius: 0.05rem;
    }
  }
  .pull-con {
    width: 100%;
    height: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    .pull-con-title1 {
      font-weight: 500;
      color: #142323;
      line-height: 28px;
      letter-spacing: 1px;
      font-size: 0.2rem;
      font-weight: 600;
    }
    .pull-con-title2 {
      font-size: 0.13rem;
    }
    .pull-con-title3 {
      color: #fff;
      width: 90%;
      line-height: 0.31rem;
      background-color: #a78d60;
      font-size: 0.14rem;
    }
    // }
  }
  .pull-con1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .pull-con-title1 {
      font-weight: 500;
      color: #142323;
      letter-spacing: 1px;
      font-size: 0.2rem;
      font-weight: 600;
      text-align: center;
    }
    .pull-con-title2 {
      margin-top: 0.2rem;
      font-size: 0.12rem;
      p {
        margin-bottom: 0.1rem;
        color: #142323;
        letter-spacing: 2px;
      }
    }
    .pull-button {
      width: 100%;
      line-height: 0.31rem;
      // font-size: 0.14rem;
      // text-align: center;
      // border-radius: 0.04rem;
      margin-top: 0.2rem;
      display: flex;
      justify-content: space-between;
      text-align: center;
      div {
        width: 40%;
        border-radius: 0.04rem;
      }
    }
  }
}
</style>